import { Component, OnInit } from '@angular/core';
import { Config } from 'datatables.net';
import { Subject } from 'rxjs';
import { PaymentService } from 'src/app/services/payment.service';

declare var $: any;

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css'],
})
export class PaymentsComponent implements OnInit {
  constructor(private service: PaymentService) {}

  role: string;

  // configs
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    language: {
      searchPlaceholder: 'Search here...',
    },
  };
  dtTrigger: Subject<any> = new Subject<any>();
  minDateForPicker: Date;
  maxDateForPicker: Date;

  dropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Deselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };

  // fill filters
  ids: any[] = [];

  // filter
  filterPaymentType = '';
  filterIsMonthRange = false;
  filterDateSelection = '';
  filterIds: any[] = [];

  data = [];
  isView = false;

  ngOnInit(): void {
    this.role = sessionStorage.getItem('role');
    this.initFilter();
  }

  initFilter() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    this.minDateForPicker = new Date(currentYear, currentMonth);
    this.maxDateForPicker = new Date(currentYear, currentMonth + 1);
  }

  applyFilters() {}

  resetFilters() {
    this.filterIsMonthRange = false;
    this.filterDateSelection = '';
    this.filterIds = [];
    this.isView = false;
  }

  // events
  onPaymentTypeChange(e) {
    this.resetFilters();
    this.service.getIds(this.filterPaymentType).subscribe((data: any[]) => {
      this.ids = data;
      console.log(this.ids);
    });
  }
}
